import { Skeleton } from '@components/atoms/Skeleton/Skeleton';

import { useResponsive } from '@utils/hooks/useResponsive';

import { LoginActionsWrapper, SkeletonHeaderWrapper } from './Header.styled';

export const SkeletonHeader = () => {
    const isSm = useResponsive('sm');

    return (
        <SkeletonHeaderWrapper>
            <Skeleton height={50} width={isSm ? 150 : 200} />
            <LoginActionsWrapper>
                <Skeleton height={50} width={isSm ? 150 : 300} />
            </LoginActionsWrapper>
        </SkeletonHeaderWrapper>
    );
};
